import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {AssistanceBill, BILL_STATUSES, BILL_TYPE} from '../../../models/assistance-bill';
import {Country} from '../../../models/country';
import {AssistancePrice} from "../../../models/assistance-price";

@Component({
    selector: 'edit-assistance-bill-form',
    templateUrl: './edit-assistance-bill-form.component.html',
    styleUrls: ['./edit-assistance-bill-form.component.css'],
    standalone: false
})
export class EditAssistanceBillFormComponent implements OnInit, OnChanges {

  @Input() bill: AssistanceBill;
  @Input() price: AssistancePrice;
  @Input() disabled: EventEmitter<boolean>;
  @Input() country: Country;
  @Output() update = new EventEmitter<AssistanceBill>();
  @Output() cancelEvent = new EventEmitter();

  inputFocused = new EventEmitter<boolean>();
  BILL_STATUSES = BILL_STATUSES;
  select_tab = new EventEmitter<number>();
  isDisabled = false;

  type_fixed = 1;
  type_unit = 2;

  constructor() {
  }

  ngOnInit() {
    this.select_tab.emit(0);

    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
        this.select_tab.emit(0);
      });
    }
  }

  ngOnChanges(changes: any) {
    this.inputFocused.emit(true);
    this.select_tab.emit(0);
  }

  setActive(choice: string): void {
    switch (choice) {
      case 'Extras':
        this.select_tab.emit(1);
        break;
    }
  }

  onChangeExtraValue(value, pos) {
    if (this.bill.bill_price_extras.length > 0 && this.price.assistance_price_extras.length > 0) {
      if (this.bill.bill_price_extras[pos].price) {
        this.bill.price_billed -= this.bill.bill_price_extras[pos].price;
      }

      this.bill.bill_price_extras[pos].price =
        Math.round(value * this.price.assistance_price_extras[pos].price * 100) / 100;
      this.bill.price_billed += this.bill.bill_price_extras[pos].price;
    }
  }

  saveAssistanceBill() {
    this.isDisabled = true;

    for (let i = 0; i < this.bill.bill_price_extras.length; i++) {
      if (!this.bill.bill_price_extras[i].bill_id && !this.bill.bill_price_extras[i].value) {
        this.bill.bill_price_extras.splice(i, 1);
        i--;
      }
    }
    if (this.bill.additional > 0) {
      this.bill.bill_type = BILL_TYPE.B;
    } else {
      this.bill.bill_type = BILL_TYPE.A;
    }
    this.update.emit(this.bill);
  }

  onCancel() {
    this.cancelEvent.emit();
  }
}
